<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <edit-mating-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <mating-detail />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import EditMatingSideNav from "./components/EditMatingSideNav.vue"
import MatingDetail from "./components/MatingDetail.vue"

export default {
    name: 'Animal_edit_page',
    components: {
        EditMatingSideNav,
        MatingDetail
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {
        
    },
}
</script>